import React, { useEffect, useState } from "react";
import { PageHeader, Section } from "@/components/Common";
import { Calendar, MapPin } from "lucide-react";
import api from "@/lib/api";

export function Events() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then(r => setEvents(r.data || [])); }, []);
  return (
    <div data-testid="events-page">
      <PageHeader eyebrow="Events" title="Gather. Celebrate. Build community."
        subtitle="From cultural galas to youth recognition ceremonies — find an event near you." />
      <Section>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {events.map((e) => (
            <article key={e.id} className="card-soft overflow-hidden" data-testid={`event-${e.id}`}>
              <div className="h-52 overflow-hidden"><img src={e.image_url} alt={e.title} className="w-full h-full object-cover hover:scale-105 transition duration-500" /></div>
              <div className="p-6">
                <span className="inline-block text-[10px] font-semibold tracking-widest uppercase bg-[var(--bcol-gold)]/10 text-[var(--bcol-navy)] px-2 py-1 rounded mb-3">{e.category}</span>
                <h3 className="font-display text-2xl text-[var(--bcol-navy)] mb-2">{e.title}</h3>
                <p className="text-sm text-[var(--bcol-muted)] mb-4 line-clamp-3">{e.description}</p>
                <div className="flex flex-wrap gap-3 text-xs text-[var(--bcol-muted)]">
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3 text-[var(--bcol-gold)]" /> {new Date(e.date).toLocaleString()}</span>
                  <span className="flex items-center gap-1"><MapPin className="w-3 h-3 text-[var(--bcol-gold)]" /> {e.location}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </Section>
    </div>
  );
}

export function Programs() {
  const programs = [
    { t: "Cultural Heritage Programs", d: "Language classes, dance, music, storytelling and history workshops for all ages.", img: "https://images.unsplash.com/photo-1509099863731-ef4bff19e808?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
    { t: "Graduate Recognition", d: "Annual ceremony honoring high school and college graduates with scholarships and mentorship.", img: "https://images.unsplash.com/photo-1627556704243-5f0771d90783?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
    { t: "Youth Leadership Academy", d: "Mentorship circles, public speaking, civic engagement, and career exposure for ages 13–22.", img: "https://customer-assets.emergentagent.com/job_community-voice-71/artifacts/mz1bxp3h_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2011_44_40%20AM.png" },
    { t: "Family Support & Resources", d: "Help newcomers navigate housing, schools, healthcare, employment, and immigration resources.", img: "https://images.pexels.com/photos/6647025/pexels-photo-6647025.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { t: "Economic Empowerment", d: "Workshops on entrepreneurship, financial literacy, and small business support for community members.", img: "https://customer-assets.emergentagent.com/job_community-voice-71/artifacts/rq97sef8_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2011_40_33%20AM.png" },
  ];
  return (
    <div data-testid="programs-page">
      <PageHeader eyebrow="Programs" title="Five pillars of community impact."
        subtitle="Year-round programs supporting culture, education, health, family, leadership, and economic growth." />
      <Section>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {programs.map((p) => (
            <div key={p.t} className="card-soft overflow-hidden" data-testid={`program-${p.t.toLowerCase().replace(/\s/g,'-')}`}>
              <div className="h-52 overflow-hidden"><img src={p.img} alt={p.t} className="w-full h-full object-cover hover:scale-105 transition duration-500" /></div>
              <div className="p-6">
                <h3 className="font-display text-xl text-[var(--bcol-navy)] mb-2">{p.t}</h3>
                <p className="text-sm text-[var(--bcol-muted)] leading-relaxed">{p.d}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
